import { createAction } from 'redux-actions';
import { createSelector } from 'reselect';
import _ from 'lodash';
import SwaggerAPI from 'data/SwaggerAPI';
import { Roles } from 'utils/authHelpers';

const SET_FIELD_VIEW = 'activeSettings/SET_FIELD_VIEW';
const SET_DASHBOARD_VIEW = 'activeSettings/SET_DASHBOARD_VIEW';
const SET_ADMIN_VIEW = 'activeSettings/SET_ADMIN_VIEW';
const SET_CONVERT_PPM = 'activeSettings/SET_CONVERT_PPM';
const SET_CONVERT_TEMP = 'activeSettings/SET_CONVERT_TEMP';
const SET_CONVERT_UNITS = 'activeSettings/SET_CONVERT_UNITS';
const SET_SELECTED_ORG = 'activeSettings/SET_ORG';

const FETCH_INSTANCE_PERMISSIONS = 'activesettings/FETCH_INSTANCE_PERMISSIONS';
const FETCH_INSTANCE_ROLES = 'activesettings/FETCH_INSTANCE_ROLES';

const CURRENT_USER_PERMISSIONS = 'users/CURRENT_USER_PERMISSIONS';
const CURRENT_USER_ROLES = 'users/CURRENT_USER_ROLES';

const initialState = {
  search: '',
  fieldView: 'field_map', // field_map, field_thumb, field_table
  dashboardView: 'map', // stats, map, charts
  adminView: undefined, // orgs, users
  selectedOrg: {},
  convertPPM: false,
  convertTemp: false,
  convertUnits: true,
  instancePermissions: undefined,
  instanceRoles: undefined,
  currentUserPermissions: [],
  currentUserRoles: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INSTANCE_PERMISSIONS:
      return { ...state, instancePermissions: action.payload };
    case FETCH_INSTANCE_ROLES:
      return { ...state, instanceRoles: action.payload };
    case SET_FIELD_VIEW:
      return { ...state, fieldView: action.fieldView };
    case SET_DASHBOARD_VIEW:
      return { ...state, dashboardView: action.dashboardView };
    case SET_ADMIN_VIEW:
      return { ...state, adminView: action.adminView };
    case SET_CONVERT_PPM:
      return { ...state, convertPPM: action.convertPPM };
    case SET_CONVERT_TEMP:
      return { ...state, convertTemp: action.convertTemp };
    case SET_CONVERT_UNITS:
      return { ...state, convertUnits: action.convertUnits };
    case SET_SELECTED_ORG:
      return { ...state, selectedOrg: action.organization };
    case CURRENT_USER_PERMISSIONS:
      return {
        ...state,
        currentUserPermissions: action.permissions,
      };
    case CURRENT_USER_ROLES:
      return {
        ...state,
        currentUserRoles: action.roles,
      };
    default:
      return state;
  }
};

const ActiveSettings = (function () {
  const getInstancePermissions = (state) => state.activeSettings.instancePermissions;
  const getInstanceRoles = (state) => state.activeSettings.instanceRoles;
  const getFieldView = (state) => state.activeSettings.fieldView;
  const getDashboardView = (state) => state.activeSettings.dashboardView;
  const getAdminView = (state) => state.activeSettings.adminView;
  const getConvertPPM = (state) => state.activeSettings.convertPPM;
  const getConvertTemp = (state) => state.activeSettings.convertTemp;
  const getConvertUnits = (state) => state.activeSettings.convertUnits;
  const getActiveOrg = (state) => state.activeSettings.selectedOrg;
  const getCurrentUserPermissions = (state) => state.activeSettings.currentUserPermissions;
  const getCurrentUserRoles = (state) => state.activeSettings.currentUserRoles;

  const fetchInstancePermissions = createAction(FETCH_INSTANCE_PERMISSIONS, SwaggerAPI.getInstancePermissions);
  const fetchInstanceRoles = createAction(FETCH_INSTANCE_ROLES, SwaggerAPI.getInstanceRoles);

  const setFieldView = (fieldView) => ({ type: SET_FIELD_VIEW, fieldView });
  const setDashboardView = (dashboardView) => ({ type: SET_DASHBOARD_VIEW, dashboardView });
  const setAdminView = (adminView) => ({ type: SET_ADMIN_VIEW, adminView });
  const setConvertPPM = (convertPPM) => ({ type: SET_CONVERT_PPM, convertPPM });
  const setConvertTemp = (convertTemp) => ({ type: SET_CONVERT_TEMP, convertTemp });
  const setConvertUnits = (convertUnits) => ({ type: SET_CONVERT_UNITS, convertUnits });
  const setSelectedOrg = (organization) => ({ type: SET_SELECTED_ORG, organization });
  const setCurrentUserPermissions = (permissions) => ({ type: CURRENT_USER_PERMISSIONS, permissions });
  const setCurrentUserRoles = (roles) => ({ type: CURRENT_USER_ROLES, roles });

  const getIsSuper = createSelector([getCurrentUserRoles], (currentRoles) => {
    return _.includes(currentRoles, Roles.Super);
  });

  const getIsAdmin = createSelector([getCurrentUserRoles], (currentRoles) => {
    return _.includes(currentRoles, Roles.Admin);
  });

  return {
    getInstancePermissions,
    getInstanceRoles,
    getFieldView,
    getDashboardView,
    getAdminView,
    getConvertPPM,
    getConvertTemp,
    getConvertUnits,
    getCurrentUserPermissions,
    getCurrentUserRoles,
    fetchInstancePermissions,
    fetchInstanceRoles,
    setFieldView,
    setDashboardView,
    setAdminView,
    setConvertPPM,
    setConvertTemp,
    setConvertUnits,
    getActiveOrg,
    setSelectedOrg,
    setCurrentUserPermissions,
    setCurrentUserRoles,
    reducer,
    getIsSuper,
    getIsAdmin,
  };
})();

export default ActiveSettings;
